import React, { useState } from 'react';
import api from '../api';
import { FaEnvelope, FaPaperPlane } from 'react-icons/fa';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [msg, setMsg] = useState('');



  const handleSubscribe = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
     await api.post('/Newsletter/subscribe', { email });
      setStatus('success');
      setEmail('');
      
      // Reset success message after 5 seconds
      setTimeout(() => {
        setStatus('idle');
      }, 5000);

    } catch (err) {
      console.error(err);
      setStatus('error');
      setMsg(err.response?.data || "Something went wrong. Try again.");
      
      setTimeout(() => {
        setStatus('idle');
        setMsg('');
      }, 3000);
    }
  };

  return (
    <section className="newsletter-section py-5" style={{ background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)' }}>
      <div className="container">
        <div className="row align-items-center">
          
          {/* Left Side */}
          <div className="col-lg-5 text-white mb-4 mb-lg-0">
            <div className="d-flex align-items-center mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '60px', height: '60px', background: 'rgba(255, 255, 255, 0.2)', backdropFilter: 'blur(10px)' }}>
                <FaEnvelope style={{ fontSize: '1.8rem' }} />
              </div>
              <div>
                <h3 className="fw-bold mb-1">Subscribe to Our Newsletter</h3>
                <p className="mb-0 small opacity-75">Stay updated with latest solar news</p>
              </div>
            </div>
            
            <div className="benefits p-4 rounded-3" style={{ background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.3)' }}>
              <ul className="list-unstyled mb-0">
                <li className="mb-2" style={{ color: '#ffffff' }}><i className="bi bi-check-circle-fill me-2" style={{ color: '#FFD700' }}></i>Latest solar subsidy updates</li>
                <li className="mb-2" style={{ color: '#ffffff' }}><i className="bi bi-check-circle-fill me-2" style={{ color: '#FFD700' }}></i>Exclusive offers & discounts</li>
                <li className="mb-2" style={{ color: '#ffffff' }}><i className="bi bi-check-circle-fill me-2" style={{ color: '#FFD700' }}></i>Solar tips & maintenance guides</li>
                <li className="mb-0" style={{ color: '#ffffff' }}><i className="bi bi-check-circle-fill me-2" style={{ color: '#FFD700' }}></i>No spam, unsubscribe anytime</li>
              </ul>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="col-lg-7">
            <div className="card border-0 shadow-lg">
              <div className="card-body p-4">
                
                {status === 'success' ? (
                  <div className="text-center py-4">
                    <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px', background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)' }}>
                      <i className="bi bi-check-lg text-white" style={{ fontSize: '3rem' }}></i>
                    </div>
                    <h4 className="fw-bold text-success mb-2">Successfully Subscribed! 🎉</h4>
                    <p className="text-muted mb-0">Thank you! You'll receive updates soon.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubscribe}>
                    <div className="row g-3">
                      <div className="col-12">
                        <label className="form-label fw-semibold text-dark">Email Address</label>
                        <div className="input-group input-group-lg">
                          <span className="input-group-text bg-light border-0"><FaEnvelope className="text-success" /></span>
                          <input 
                            type="email" 
                            className="form-control border-0 bg-light" 
                            placeholder="Enter your email address" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            required 
                            disabled={status === 'loading'}
                          />
                        </div>
                        {status === 'error' && <small className="text-danger mt-2 d-block">{msg}</small>}
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn btn-success btn-lg w-100 rounded-pill" 
                          style={{ background: 'linear-gradient(135deg, #00D084 0%, #00A86B 100%)', border: 'none' }}
                          disabled={status === 'loading'}
                        >
                          {status === 'loading' ? 'Subscribing...' : <><FaPaperPlane className="me-2" /> Subscribe Now</>}
                        </button>
                      </div>
                      <div className="col-12">
                        <p className="text-muted text-center small mb-0"><i className="bi bi-shield-check text-success me-1"></i>We respect your privacy. Your email is safe with us.</p>
                      </div>
                    </div>
                  </form>
                )}

              </div>
            </div>
            <div className="text-center mt-3">
              <small className="text-white opacity-75"><i className="bi bi-people-fill me-2"></i>Join 2,500+ subscribers from Bihar & Jharkhand</small>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Newsletter;